export const writeObject = (obj, parent) => {
  const list = document.createElement('ul');
  // How to loop an object (2 of many ways):
  // Object.keys(obj).forEach(key => console.log(`${key}: ${obj[key]}`));
  // for (let [key, v] of Object.entries(obj)) console.log(`${key}: ${v}`);
  Object.entries(obj).forEach(([key, value]) => {
    if (['geometry', 'område', 'SHAPE'].indexOf(key) > -1) return; // skip
    // console.log(`${key}: ${value} (${typeof value})`); // null is object
    const item = document.createElement('li');
    const date = value instanceof Date;
    const nested = value && ((typeof value) === 'object') && !date;
    const displayed = date ? value.toLocaleDateString() : (nested ? '' : value);
    item.innerHTML = `${key}: ${displayed}`;
    if (nested) writeObject(value, item);
    list.appendChild(item);
  });
  parent.appendChild(list);
  return list;
};

export const stampEnvironment = () => {
  const e = getEnvironment();
  document.body.classList.add(e);
  if (e !== 'production') document.getElementById('environment').hidden = false;
};

const getEnvironment = () =>  {
  const srv = window.location.href.split('/')[2];
  if (srv.indexOf('localhost') > -1) return 'localhost';
  if (srv.indexOf('utv') > -1) return 'development';
  if (srv.indexOf('test') > -1) return 'staging';
  return 'production';
};

export const separateObjectKeysStartingWith = (obj, keyCheck) => {
  const without = {};
  const w = {};
  Object.entries(obj).forEach(([key, value]) => {
    if (key.startsWith(keyCheck)) w[key.slice(keyCheck.length)] = value;
    else without[key] = value;
  });
  return [without, w];
};
